import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'
import { Spinner } from '../components/Spinner'

export function RequireAuth() {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <Spinner label="Checking session" />
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />

  return <Outlet />
}

